import Vue from 'vue';

// Kiosk card payments on the kiosk's own card reader, driven by payments-api
// through greet-menu-api. Errors propagate to the store actions so callers can
// tell a failed request from an answer.
export const startCardReaderPaymentRequest = ({ session, order }) => {
  return Vue.axios.post(`/payments/greet-card-reader/start`, {
    session,
    order,
  });
};

export const fetchCardReaderPaymentRequest = ({ paymentUUID }) => {
  return Vue.axios.get(`/payments/greet-card-reader/${paymentUUID}`);
};

export const stopCardReaderPaymentRequest = ({ paymentUUID }) => {
  return Vue.axios.post(`/payments/greet-card-reader/${paymentUUID}/stop`);
};
